import { ProviderWebsiteModel } from '../../../shared/models/provider-website-model';
import { Serializable } from '@admin/core/models/serializable';

export class ChannelSubscriberStatModel
  implements Serializable<ChannelSubscriberStatModel>
{
  fromObject(obj: any): ChannelSubscriberStatModel {
    Object.assign(this, obj);
    this.channel = null;

    if (obj.channel != null) {
      let t = new ProviderWebsiteModel();
      t = t.fromObject(obj.channel);
      this.channel = t;
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public totalCount: number;
  public countPerChannel: number;
  public channel: ProviderWebsiteModel;
}
